import React from 'react';
import SmartCardSection from '../smart-card-section/SmartCardSection';
import useNextBestOffer from './useNextBestOffer';
import { NextBestOfferByAccountType } from './nextBestOffer.query';

type NextBestOfferProps = {
  accountType: NextBestOfferByAccountType;
};

export function NextBestOffer({ accountType }: NextBestOfferProps) {
  const { contentfulSectionCard, cardGrouping } = useNextBestOffer(accountType);

  return (
    <SmartCardSection
      cardGrouping={cardGrouping}
      standaloneCards={[]}
      contentfulSectionCard={contentfulSectionCard}
    />
  );
}
